import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState, useMemo } from 'react';
import {
	Box,
	DialogContent,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Paper,
	TableRow,
	Select,
	TableCell,
	TextField,
	TableHead,
	Table,
	TableContainer,
} from '@mui/material';
import { DateTime } from 'luxon';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
	getGpsrInvoicesList,
	getGpsrInvoicesListLoad,
	getGpsrPlans,
	getGpsrProductTypes,
} from 'redux/reducers/gpsr/selectors';
import {
	editGpsrCustomerRequest,
	getGpsrInvoicesListRequest,
	getGpsrPlansRequest,
} from 'redux/reducers/gpsr/reducer';
import { DatePickerComponent } from 'ui/DatePickerComponent';
import { EasTableWithFilter } from 'ui/EasTableWithFilter';
import { PAGE_SIZE } from 'services/constants/env';
import { TGpsrInvoicesListDialogProps } from './types';
import { validationSchema } from './validationSchema';
import { gpsrInvoiceListTableStructure } from '../data/gpsr-invoice-list-table-structure';

export const GpsrInvoicesListDialog: FC<TGpsrInvoicesListDialogProps> = ({ open, setClose }) => {
	const dispatch = useDispatch();
	const invoicesList = useSelector(getGpsrInvoicesList);
	const invoicesListLoad = useSelector(getGpsrInvoicesListLoad);

	const adaptedInvoicesList = useMemo(() => {
		if (!invoicesList) return null;
		return {
			...invoicesList,
			data: invoicesList.data.map(item => ({
				...item,
				id: item.invoiceId,
			})),
		};
	}, [invoicesList]);

	useEffect(() => {
		if (open) {
			dispatch(
				getGpsrInvoicesListRequest({
					pageNumber: 1,
					pageSize: PAGE_SIZE,
				}),
			);
		}
	}, [dispatch, open]);

	return (
		<Dialog open={open} fullWidth maxWidth="lg">
			<DialogTitle color="primary">Invoices List</DialogTitle>
			<DialogContent
				sx={{
					p: '0 12px 0px 12px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						gap: '16px',
					}}
				>
					<Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '4px' }}>
						<EasTableWithFilter
							tableStructure={gpsrInvoiceListTableStructure}
							items={adaptedInvoicesList}
							itemsIsLoading={invoicesListLoad}
							handleAction={() => {}}
						/>
					</Box>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						setClose();
					}}
				>
					Cancel
				</Button>
				{/* <Button
						type="button"
						onClick={handleParse}
						autoFocus
					>
						Parse
					</Button> */}

				<Button
					type="submit"
					// onClick={() => {
					// 	console.log('Button send clicked');
					// 	formikGpsr.handleSubmit();
					// }}
					autoFocus
				>
					Send
				</Button>
			</DialogActions>
		</Dialog>
	);
};
